export function toTitleCase(text) {
  if (!text) return "";
  
  return text
    .toLowerCase()
    .split(" ")
    .filter(word => word.trim() !== "") // evita dobles espacios
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function normalizeText (text = ""){
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
}